<template>
  <div id="content" class="content">
    <Transition :name="isMobile ? '' : 'slide'">
      <ApiDocsMenuComponent v-if="uiStore.getIsApiDocsMenuOpen" />
    </Transition>
    <ApiDocsHeader
      class="header --api"
      :class="[{ collapsed: uiStore.getIsApiDocsMenuOpen }]"
      @toggleMenu="toggleMenu"
    />
    <ApiDocsMain class="main --api" :class="[{ collapsed: uiStore.getIsApiDocsMenuOpen }]">
      <slot />
    </ApiDocsMain>
    <CallWidget />
  </div>
</template>

<script lang="ts" src="./ApiDocsLayout.ts"></script>

<style scoped lang="scss" src="./ApiDocsLayout.scss"></style>
